module.exports = __webpack_public_path__ + "img/draft-icon.64ea375e.svg";